import { Link } from "react-router-dom";
import logo from "../../static/images/essaar-header-logo.png";

export default function Logo({ className = "h-12 w-auto max-h-12 max-w-[42vw] object-contain object-left sm:h-16 sm:max-h-16 sm:max-w-[16rem] lg:h-20 lg:max-h-20 lg:max-w-[18.5rem]", linked = true }) {
  const image = <img src={logo} alt="Essaar Logistics" className={className} />;
  if (!linked) return image;
  return (
    <Link to="/" className="inline-flex min-w-0 shrink" aria-label="Essaar Logistics home">
      {image}
    </Link>
  );
}
